import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import styles from "./AdminVideo.module.css";
import { AxiosInstance } from "../../../../../../axios";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import Creatable from "react-select/creatable";
import { customStyles } from "../../../../../../pages/customStyles";
import Loader from "../../../../Loader";

export default function AddVideoAdminInfo() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});
  const [iframeUrl, setIframeUrl] = useState("");
  const [selectedImage, setSelectedImage] = useState();
  const [visibleImage, setVisibleImage] = useState(false);
  const [existFolderData, setExistFolderData] = useState([]);
  const location = useLocation();
  const { TITLE, FOLDER_NAME, DESCRIPTION, VIDEO_LINK, FOLDER_PK, DISPLAY_OPTION } = location.state || {};
  const title_ref = useRef(null);
  const des_ref = useRef(null);
  const video_ref = useRef(null);
  const folder_ref = useRef(null);

  const [initialfields, setInitialfields] = useState({
    id: "",
    folder_name: "",
    folder_pk: "",
    description: "",
    title: "",
    img_type: 0,
    display_option: 1,

    created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: userid || "",
    is_deleted: 0,
    files: [],
  });

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  useEffect(() => {
    handleMapNewFolderNames();
  }, []);



  const handleMapNewFolderNames = async () => {
    setIsLoading(true);
    return AxiosInstance.post("/api/gallery/folderList", folderPayloadImage)

      .then((res) => {

        const uniqueSubcategories = res.data?.data?.map((item, index) => ({
          value: item.id,
          label: item.folder_name,
        }));
        setExistFolderData(uniqueSubcategories);
        if (id) {
          let imageData = res?.data?.data?.filter(
            (item) => item.id === parseInt(id)
          );
          setVisibleImage(
            imageData[0]?.display_option === 1
              ? "yes"
              : imageData[0]?.display_option === 0
                ? "no"
                : null
          );
          // setInitialfields((prev) => ({
          //   ...prev,
          //   folder_pk: imageData[0]?.id,
          //   folder_name: imageData[0]?.folder_name,
          //   title: imageData[0]?.title,
          //   gallery_path: imageData[0]?.gallery_path,
          // }));
          setIframeUrl(imageData[0]?.gallery_path);
          // setSelectedImage(imageData[0]);
        }
      })
      .catch((error) => {
        console.error(error); // Log the error for debugging
        return error;
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const folderPayloadImage = {
    type: 0
  };
  useEffect(() => {
    setInitialfields({
      title: TITLE,
      description: DESCRIPTION,
      folder_name: FOLDER_NAME,
      folder_pk: FOLDER_PK,
      display_option: DISPLAY_OPTION,
      gallery_path: VIDEO_LINK,
    })
  }, [TITLE, FOLDER_NAME, DESCRIPTION, FOLDER_PK, VIDEO_LINK])
  const handleIframeChange = (e) => {
    const iframeUrl = e.target.value.trim(); // Get the value of the textarea
    setError({}); // Reset errors
    const youtubeRegex =
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = iframeUrl.match(youtubeRegex);
    // Check if the URL matches the YouTube format
    if (!match) {
      setError({ iframeUrl: "Please enter a valid YouTube URL/iframe Url" });
      return;
    }

    // Extract the video ID (the 1st match group)
    const videoId = match[1];

    // Set the iframe URL state to store only the video ID
    setIframeUrl(iframeUrl);
  };
  const handleFolderNameChange = (selectedOptions, dname) => {
    // const isNew = selectedOptions.__isNew__;
    if (dname === "folder_pk") {
      setInitialfields((prevState) => ({
        ...prevState,
        ["folder_pk"]: selectedOptions.value,
        ["folder_name"]: selectedOptions.label,
        // ...(isNew && { name: "", id: "" }),
      }));
      setError({
        ...error,
        [dname]: "",
      });
    }
  };


  const handleChange = (event) => {
    const { name, files, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });

  };

  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.folder_name) {
      folder_ref.current.focus();
    } else if (!COMSECFO.title) {
      title_ref.current.focus();
    }
    // else if (!COMSECFO.description) {
    //   des_ref.current.focus();
    // }
    else if (!COMSECFO.iframeUrl) {
      video_ref.current.focus();
    }
  };
  const detectPlatform = (url) => {
    if (/^(https?:\/\/)?(www\.)?(facebook\.com|fb\.watch)\//.test(url)) return "Facebook";
    if (/^(https?:\/\/)?(www\.)?instagram\.com\//.test(url)) return "Instagram";
    if (/^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\//.test(url)) return "YouTube";
    return null;
  };
  const validateFields = (data) => {
    const errors = {};

    if (!data.folder_name) {
      errors.folder_name = "Please select or enter new folder name";
    }
    if (!data.title) {
      errors.title = "Please enter title";
    } else if (data.description.length > 200) {
      errors.description = "Description not exceed 200 characters";
    }
    // if (!data.description) {
    //   errors.description = "Please enter description";
    // }
    const urlRegex =
      /^(https?:\/\/(localhost(:\d{1,5})?|((?!-)[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+|\d{1,3}(?:\.\d{1,3}){3}))(:\d{1,5})?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?)$/iu;
    if (!data.gallery_path) {
      errors.gallery_path = "Please enter a valid URL";
    } else if (!urlRegex.test(data.gallery_path)) {
      errors.gallery_path = "Please enter a valid URL";
    }
    //  else {
    //   const platform = detectPlatform(data.gallery_path);
    //   if (!platform) {
    //     errors.gallery_path = "Please enter a valid YouTube, Facebook, or Instagram URL";
    //   }
    // }

    // Validate iframe content
    // if (!iframeUrl) {
    //   errors.iframeUrl = "Please enter a valid Iframe URL";
    // }
    validateFocusCommentSection(data);
    return errors;
  };

  const handleSave = () => {
    const err_bnh = validateFields(initialfields);
    if (initialfields.description?.length > 200) {
      err_bnh.description = "Description not exceed 200 characters";
    }
    if (Object.keys(err_bnh).length === 0) {
      try {
        const filesArray = [
          {
            path: initialfields.gallery_path,
            original: null,
            description: initialfields.description,
          },
        ];
        if (id) {
          // If an id is provided, update the data
          const updateCoures = {
            id: id,
            display_option: initialfields.display_option,
            files: filesArray,
            folder_name: initialfields.folder_name,
            folder_pk: initialfields.folder_pk,
            title: initialfields.title,
            img_type: 0,
            created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid || "",
            is_deleted: 0,
          };

          AxiosInstance.post(`/api/gallery/add`, updateCoures)
            .then((res) => {
              if (res.data.status === true) {
                toast.success(res.data.message);
                navigate(-1);
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          // If no id is provided, add the new data
          const createCouresInfoData = {
            id: "",
            display_option: 1,
            files: filesArray,
            folder_name: initialfields.folder_name,
            folder_pk: initialfields.folder_pk,
            title: initialfields.title,
            img_type: 0,
            created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid || "",
            is_deleted: 0,
            files: filesArray,
          };
          AxiosInstance.post(`/api/gallery/add`, createCouresInfoData)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);
                navigate("/GalleryVideos");
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(err_bnh);
    }
  };


  const handleImageUploadFinal = async () => {
    const filesArray = [
      {
        path: iframeUrl,
        original: null,
        description: initialfields.description,
      },
    ];
    let finalObj = id
      ? {
        id: id,
        display_option: visibleImage === "yes" ? 1 : 0,
        files: filesArray,
        folder_name: initialfields.folder_name,
        folder_pk: initialfields.folder_pk,
        title: initialfields.title,
        img_type: 0,
        created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid || "",
        is_deleted: 0,
      }
      : {
        id: "",
        display_option: visibleImage === "yes" ? 1 : 0,
        files: filesArray,
        folder_name: initialfields.folder_name,
        folder_pk: initialfields.folder_pk,
        title: initialfields.title,
        img_type: 0,
        created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss"),
        created_by: userid || "",
        is_deleted: 0,
        files: filesArray,
      };
    AxiosInstance.post(`/api/gallery/add`, finalObj)
      .then((res) => {

        if (res.status === 200) {
          toast.success(res.data.message);

          if (initialfields.folder_name) {
            navigate(-1);
          } else {
            navigate("/GalleryVideos");
          }
        } else {
          toast.error(res.data.message);
        }
        if (!id) {
          setInitialfields({
            id: "",
            folder_pk: initialfields.folder_pk,
            folder_name: "",
            title: initialfields.title,
            img_type: 0,
            display_option: 1,
            created_dt: dayjs().format("YYYY-MM-DD HH:mm:ss HH:mm:ss"),
            created_by: userid || "",
            is_deleted: 0,
            files: [],
          });
        }
        handleMapNewFolderNames();
      })
      .catch(() => {
        console.error(error); // Log the error for debugging
        return error;
      });
  };




  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      <Loader />
    </div>
  ) : (
    <div className={`${styles.GalleryInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">{id ? "Edit Video" : "Add New Video"}</h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/GalleryVideos"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton"
              >
                {id ? "Back to View Videos" : "Back to Videos"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
              >
                Save Video
              </Link>
            </li>
          </ul>
        </div>

        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Video Details</legend>
            <form className="row g-3">
              {/* Video Title */}
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="CourseGrouping"
                    className="form-label confirm_value "
                  >
                    Title
                  </label>
                  <input
                    ref={title_ref}
                    type="text"
                    name="title"
                    className="desc_input_text w-100 rounded-2 input-font-size-sm py-2"
                    value={initialfields.title}
                    onChange={handleChange}
                    placeholder="Enter the title"
                    maxLength={500}
                  />
                  {error.title && (
                    <small className="error_message">{error.title}</small>
                  )}
                </div>
              </div>
              {/* --------Folder Name */}
              <div className="col-md-6">
                <label
                  htmlFor="CourseGrouping"
                  className="form-label confirm_value"
                >
                  Folder Name
                </label>
                {/* <Creatable
                  // ref={sub_category_ref}
                  className="shadow-none input-font-size"
                  name="CourseGrouping"
                  value={{
                    value: initialfields.folder_name,
                    label: initialfields.folder_name,
                  }}
                  onChange={(e) =>
                    // handlechangeSelectDropdown
                    handleFolderNameChange(e)
                  }
                  options={existFolderData
                    ?.filter((item) => item && item.label)
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true} // Enables search functionality
                  placeholder="Select or Enter New Folder Name"
                  maxMenuHeight={200} // Limit dropdown height (5 options max)
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles} // Apply custom styles if needed
                  formatCreateLabel={(inputValue) => `Add New: ${inputValue}`} // Customize "Add New" text
                /> */}
                <Creatable
                  ref={folder_ref}
                  className={`shadow-none input-font-size `}
                  name="authorGrouping"
                  value={
                    initialfields.folder_name && initialfields.folder_pk
                      ? {
                        value: initialfields.folder_pk,
                        label: initialfields.folder_name,
                      }
                      : initialfields.folder_name
                        ? { value: "", label: initialfields.folder_name }
                        : null
                  }
                  onChange={(option) =>
                    handleFolderNameChange(option, "folder_pk")
                  }
                  options={existFolderData
                    ?.filter((item) => item && item.label)
                    .sort((a, b) =>
                      a.label.trim().localeCompare(b.label.trim())
                    )}
                  isSearchable={true}
                  isValidNewOption={() => false}
                  placeholder="Select folder name"
                  maxMenuHeight={200}
                  filterOption={(option, searchText) =>
                    option.label
                      .toLowerCase()
                      .includes(searchText.toLowerCase())
                  }
                  styles={customStyles}
                // formatCreateLabel={(inputValue) => `Add New : ${inputValue}`}
                />
                {error.folder_name && (
                  <small className="error_message">{error.folder_name}</small>
                )}
              </div>
              {/*  Visible */}
              {id ? (
                <div className="col-md-6">
                  <label
                    htmlFor="examName"
                    className="form-label confirm_value"
                  >
                    Visible to Users
                  </label>

                  <div>
                    <input
                      // ref={optional_paper_ref}
                      className={`shadow-none input-font-size  ${styles.checkbox_radio}`}
                      type="radio"
                      id="yes"
                      name="display_option"
                      value={1}
                      // checked={initialfields.visibleImageChoice === "yes"}
                      // onChange={() =>
                      //   setInitialfields({
                      //     ...initialfields,
                      //     visibleImageChoice: "yes",
                      //   })
                      // }
                      checked={initialfields.display_option == 1}
                      onChange={handleChange}
                    />
                    <label
                      htmlFor="yes"
                      className={`${styles.margin_right} form-label confirm_value`}
                    >
                      Yes
                    </label>

                    <input
                      // ref={optional_paper_ref}
                      className={`shadow-none input-font-size ${styles.checkbox_radio}`}
                      type="radio"
                      id="no"
                      name="display_option"
                      // value={0}
                      value={0}
                      //  checked={initialfields.is_optional == 0 ? true : false}
                      //  onChange={handleChange}
                      checked={initialfields.display_option == 0}
                      onChange={handleChange}
                    />
                    <label htmlFor="no" className="form-label confirm_value">
                      No
                    </label>
                  </div>
                  {/* {error.is_optional && (
                 <small className={styles.errors}>
                   {error.is_optional}
                 </small>
               )} */}
                </div>
              ) : (
                <></>
              )}
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="CourseGrouping"
                    className="form-label confirm_value "
                  >
                    Description
                  </label>
                  <textarea
                    ref={des_ref}
                    type="text"
                    name="description"
                    style={{ resize: "none" }}
                    rows="3"
                    className="desc_input_text w-100 rounded-2 input-font-size-sm "
                    value={initialfields.description}
                    onChange={handleChange}
                    placeholder="Enter the description"
                  // maxLength={200}
                  />

                  {error.description && (
                    <small className="error_message">{error.description}</small>
                  )}
                </div>
              </div>
              {/* Iframe */}
              <div className="col-md-6">
                <div className="form-group">
                  <label
                    htmlFor="iframeUrl"
                    className={
                      id
                        ? "form-label confirm_value disabled_btn"
                        : "form-label confirm_value"
                    }
                  >
                    Video Link
                  </label>
                  <textarea
                    ref={video_ref}
                    style={{ resize: "none" }}
                    rows="3"
                    className={`desc_input_text w-100 rounded-2 input-font-size-sm ${id ? "disabled_btn" : ""
                      }`}

                    name="gallery_path"
                    disabled={id ? true : false}
                    value={initialfields.gallery_path}
                    // onChange={handleIframeChange}
                    onChange={handleChange}
                    placeholder="Paste your video link here"
                  />
                  {error.gallery_path && (
                    <small className="error_message">{error.gallery_path}</small>
                  )}
                </div>
              </div>

            </form>
          </fieldset>
        </div>
        <div className="col-md-12 col-12 ListBtn pt-2">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/GalleryVideos"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton"
              >
                {id ? "Back to View Videos" : "Back to Videos"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSave}
                className="primaryButton text-center"
              >
                Save Video
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
